import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";

const PrintOpeningBalance = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [loading, setLoading] = useState(true);
  const [listOfLedger, setLedger] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);
  const [filterLabel, setFilterLabel] = useState("");

  const fmtAmt = (v) =>
    Number(v || 0).toLocaleString(undefined, { maximumFractionDigits: 2 });

  useEffect(() => {
    document.title = "Print Opening Balance";

    const urlParams = new URLSearchParams(window.location.search);
    const defaultFYear = urlParams.get("DefaultYear") || "";
    const accountNo = urlParams.get("AccountNo") || "";
    const keywords = urlParams.get("Keywords") || "";
    const showZero = urlParams.get("ShowZeroAccounts") === "1";

    const parts = [`Year ${defaultFYear}`];
    if (accountNo) parts.push(`Code contains "${accountNo}"`);
    if (keywords) parts.push(`Name contains "${keywords}"`);
    if (!showZero) parts.push("Zero balances hidden");
    setFilterLabel(parts.join(" · "));

    axios({
      method: "post",
      url: config.base_url + "Accounts/GetOpeningBalancesByYear",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        pageNo: 1,
        pageSize: 10000,
        FYear: parseInt(defaultFYear, 10) || 0,
        AccountNo: accountNo,
        Keywords: keywords,
        ShowZeroAccounts: showZero,
      },
    })
      .then((response) => {
        if (response.data?.status_code === 1) {
          setLedger(response.data.ListofRecords || []);
          setTotalRecords(response.data.totalRecords || 0);
          setTotalDebit(response.data.TotalDebit ?? 0);
          setTotalCredit(response.data.TotalCredit ?? 0);
        } else {
          setLedger([]);
          setTotalRecords(0);
          setTotalDebit(0);
          setTotalCredit(0);
        }
        setLoading(false);
      })
      .catch(() => {
        setLedger([]);
        setLoading(false);
      });
  }, [AccessKey, UserID, MemberType]);

  const renderLedger = () => {
    if (listOfLedger.length > 0) {
      let count = 1;
      return listOfLedger.map((item, index) => (
        <tr key={index}>
          <td>{count++}</td>
          <td>{item.ID}</td>
          <td>{item.Selected_Account?.Account_code}</td>
          <td>{item.Selected_Account?.Account_desc}</td>
          <td className="text-end">{fmtAmt(item.DR_Amt)}</td>
          <td className="text-end">{fmtAmt(item.CR_Amt)}</td>
        </tr>
      ));
    }
    return (
      <tr>
        <td colSpan={6}>
          <h4
            className="mt-3"
            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
          >
            No Data Found
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <Page orientation="portrait" size="a4">
      <PrintHeader title="Opening Balances" />
      {filterLabel ? (
        <p className="small mb-2" style={{ fontSize: "10pt" }}>
          {filterLabel}
        </p>
      ) : null}
      <table className="table table-sm table-bordered table-print">
        <thead>
          <tr>
            <th colSpan={6} className="text-end">
              Total records: {totalRecords}
            </th>
          </tr>
          <tr>
            <th>Sr#</th>
            <th>ID</th>
            <th>Code</th>
            <th>Account</th>
            <th className="text-end">Debit</th>
            <th className="text-end">Credit</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td className="text-center" colSpan={6}>
                <Spinner animation="border" role="status" />
              </td>
            </tr>
          ) : (
            <>
              {renderLedger()}
              {listOfLedger.length > 0 && (
                <tr>
                  <th colSpan={4} className="text-end">
                    Grand total
                  </th>
                  <th className="text-end">{fmtAmt(totalDebit)}</th>
                  <th className="text-end">{fmtAmt(totalCredit)}</th>
                </tr>
              )}
            </>
          )}
        </tbody>
      </table>
    </Page>
  );
};

export default PrintOpeningBalance;
